import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { map } from 'rxjs';
import { RxIntuitiveTreatmentToolbarComponent } from '@modules/rx-intuitive-teeth-orchestrator/components/rx-intuitive-treatment-toolbar/rx-intuitive-treatment-toolbar.component';
import { TreatmentInformationFacade } from '@modules/treatment-information/treatment-information.facade';
import { EmptyStringAsHyphenPipe } from '@modules/treatment-information/pipes/empty-string-as-hyphen.pipe';
import { RxIntuitiveTreatmentTableComponent } from '@modules/rx-intuitive-treatment-table/rx-intuitive-treatment-table.component';
import { OrchestratorViewModeType } from '@modules/rx-intuitive-teeth-orchestrator/state/rx-intuitive-teeth-orchestrator-store';
import { RxIntuitiveTeethOrchestratorLayoutComponent } from '../rx-intuitive-teeth-orchestrator-layout/rx-intuitive-teeth-orchestrator-layout.component';
import { RxIntuitiveTeethOrchestratorFacade } from '@modules/rx-intuitive-teeth-orchestrator/rx-intuitive-teeth-orchestrator.facade';

@Component({
	selector: 'rx-intuitive-treatment-table-container',
	standalone: true,
	providers: [TreatmentInformationFacade, EmptyStringAsHyphenPipe],
	imports: [
		CommonModule,
		RxIntuitiveTeethOrchestratorLayoutComponent,
		RxIntuitiveTreatmentToolbarComponent,
		RxIntuitiveTreatmentTableComponent
	],
	templateUrl: './rx-intuitive-treatment-table-container.component.html'
})
export class RxIntuitiveTreatmentTableContainerComponent {
	readonly orchestratorViewMode$ = this.orchestratorFacade.orchestratorViewMode$;
	readonly isTableViewDisabled$ = this.orchestratorFacade.previewTreatmentListItems$.pipe(map(items => items.length === 0));

	constructor(private readonly orchestratorFacade: RxIntuitiveTeethOrchestratorFacade) {}

	changeOrchestratorViewMode(newViewMode: OrchestratorViewModeType) {
		this.orchestratorFacade.changeViewMode(newViewMode);
	}
}
